import { render, staticRenderFns } from "./stickyWrap.vue?vue&type=template&id=18090a2b&scoped=true&lang=pug&"
import script from "./stickyWrap.vue?vue&type=script&lang=js&"
export * from "./stickyWrap.vue?vue&type=script&lang=js&"
import style0 from "./stickyWrap.vue?vue&type=style&index=0&id=18090a2b&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18090a2b",
  null
  
)

export default component.exports